import { IComponentOptions } from "angular";
import templateUrl from './list-employees-roster-table.component.html';

export const ListEmployeeRosterTableComponent: IComponentOptions = {
    controller: ListEmployeesRosterTableController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        filters: "<",
        identity: "<",
        onChangeFilters: "&",
        employees: "<",
        onSetSort: "&",
        isSortingByField: "&",
        canEdit: "<",
        canProxy: "<",
        isSiteAdmin: "<",
        isImpersonated: "<",
        onProxy: "&",
        tabIndex: "<",
        onChangeTab: "&",
        isPending: "<",
        onInitOnboarding: "&",
        revokeOnboarding: "&onRevokeOnboarding",
        canInitOnboarding: "<",
        canCreateOnboarding: "<"
        //isPendingView: ""
    }
};


function ListEmployeesRosterTableController($state) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.enableOnboarding = true;
    vm.setSort = setSort;
    vm.onSortingByField = onSortingByField;
    vm.columnClass = columnClass;
    vm.triggerOnInitOnboarding = triggerOnInitOnboarding;
    vm.showOnboardingPopup = showOnboardingPopup;
    vm.isPayrollAdmin = false;
    vm.isOwner = false;
    vm.$onInit = function () {
        //console.log('yolo');
        if (vm.identity.Roles.includes("Owner")) {
            vm.isOwner = true;
        } else if (vm.identity.Roles.includes("ICD Payroll Admin")) {
            vm.isOwner = true;
        } else if (vm.identity.Roles.includes("Employment Processor") || vm.identity.Roles.includes("Payroll Processor")) {
            vm.isPayrollAdmin = true;
        } else {

        }
        console.log(vm.isOwner);
        console.log(vm.isPayrollAdmin);
    }

    function showOnboardingPopup() {
        return alert("Please reach out to Apex Support: ApexSuppport@herbjoyent.com to enable onboarding for your account.");
    }

    function onSortingByField(field) {
        return vm.isSortingByField({ field: field });
    }

    function setSort(field) {
        return vm.onSetSort({ field: field });
    }

    function columnClass(field) {
        return vm.sortDirection === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

    function triggerOnInitOnboarding(employeeId) {
        if (!vm.canCreateOnboarding) {
            alert("Please reach out to ApexSuppport@herbjoyent.com to opt into assisting with testing out this new feature.");
            return;
        } else {
            // Some additional logic if needed
            console.log("Triggering onInitOnboarding function in child component");
            console.log(vm.canInitOnboarding);
            console.log(employeeId);
            $state.go(".pendingModal", { employeeId: employeeId });
        }
    }

}
